import React, { ReactNode } from 'react'

const ContentExpander = ({
  expanded,
  children,
}: {
  expanded: boolean
  children: ReactNode
}) => {
  return (
    <div
      className={[
        'content-expander',
        expanded && 'content-expander--expanded',
      ].join(' ')}
    >
      <div className='content-expander__inner'>{children}</div>
    </div>
  )
}

export { ContentExpander }
